export const concatPath = (path: string, key: string | number) => (path ? `${path}.${key}` : `${key}`)
